import React from 'react';

import ListView from '../../components/ListView';

const ListAccounts = (props) => {
  return (
    <ListView
      count={100}
      pluralName="Accounts"
      singularName="Account"
      match={props.match}

      currentPage={1}
      totalPages={1}
      rowKey="id"
      columns={[
        {label: 'Name', key: 'name'},
        {label: 'Account ID', key: 'id'},
      ]}
      rows={[
        {name: 'Test', id: 'XXXYYYZZZAAABBB'},
        {name: 'Test 2', id: '000111222333444'},
      ]}
    />
  );
};

export default ListAccounts;
